// ABOUTME: Opens and closes the WhatsApp pre-registration configuration help.
// ABOUTME: Keeps the help interaction together with its accessible dialog state.
import React from "react";
import { Button } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import WhatsappPreRegistrationHelpDialog from "./WhatsappPreRegistrationHelpDialog";
import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";

interface WhatsappPreRegistrationHelpControlProps {
    labels: WhatsappPreRegistrationLabels;
}

const WhatsappPreRegistrationHelpControl = ({
    labels
}: WhatsappPreRegistrationHelpControlProps) => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <Button
                color="primary"
                variant="outlined"
                startIcon={<HelpOutlineIcon />}
                onClick={() => setOpen(true)}
            >
                {labels.helpButton}
            </Button>
            <WhatsappPreRegistrationHelpDialog
                open={open}
                labels={labels}
                onClose={() => setOpen(false)}
            />
        </>
    );
};

export default WhatsappPreRegistrationHelpControl;
